import { h } from 'preact';
import ChevronRightIcon from 'utils/icon/icon-chevron-right.svg';
import CloseIcon from 'utils/icon/icon-close.svg';
import { useEffect, useMemo, useState } from 'preact/hooks';
import MenuItem from '../header/menu-item';

const ListItem = ({ item, onClose }) => {
  const [opened, setOpened] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const menuClass = useMemo(() => {
    let className =
      'translate-x-full ease-in-out duration-300 absolute top-0 left-0 z-50 w-full h-full bg-white flex flex-col lg:hidden';
    if (opened) {
      className += ' !translate-x-0';
    }
    if (!mounted) {
      className += ' !hidden';
    }
    return className;
  }, [opened, mounted]);

  const closeHandle = () => {
    setOpened(false);
    onClose();
  };

  if (item.navs.length) {
    return (
      <div className="px-24 [&:last-child>*]:border-0">
        <button
          className="border-b py-24 border-grey-300 text-left w-full flex gap-12 items-center"
          onClick={() => setOpened(true)}
        >
          <span className="flex-1 !normal-case">
            <span
              className={`heading-3 ml:display-4 ${
                item.highlighted ? 'text-misc-sale ml:text-error' : ''
              }`}
            >
              {item.text}
            </span>
          </span>
          <ChevronRightIcon className="h-12 w-auto" />
        </button>
        <div className={menuClass}>
          <div className="px-24 py-16 w-full flex items-center border-b border-grey-300 gap-24 mb-18">
            <button
              className="flex-1 gap-24 flex"
              onClick={() => setOpened(false)}
            >
              <div className="w-24 h-24 flex items-center">
                <ChevronRightIcon className="rotate-180 h-18 w-auto" />
              </div>
              <div className="flex-1 lc:heading-3 ml:display-4 text-left !normal-case">
                {item.text}
              </div>
            </button>
            <button
              onClick={closeHandle}
              className="w-24 h-24 flex items-center justify-center"
            >
              <CloseIcon className="h-24 w-auto" />
            </button>
          </div>
          <div className="flex-1 min-h-0 overflow-y-auto overscroll-none">
            <MenuItem {...item} />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="px-24 [&:last-child>*]:border-0">
      <a
        href={item.url}
        className="border-b py-24 border-grey-300 text-left w-full flex gap-12 items-center"
      >
        <div className="flex-1 text-left !normal-case">
          <span
            className={`lc:heading-3 ml:display-4 ${
              item.highlighted ? 'text-misc-sale ' : ''
            }`}
          >
            {item.text}
          </span>
        </div>
      </a>
    </div>
  );
};

const MobileMenuList = ({ navigation, onClose }) => (
  <div>
    {navigation.map((item) => (
      <ListItem key={item.id} item={item} onClose={onClose} />
    ))}
  </div>
);

export default MobileMenuList;
